import { render, staticRenderFns } from "./CathayPropertyCarInsurance.vue?vue&type=template&id=7e82a234"
import script from "./CathayPropertyCarInsurance.vue?vue&type=script&lang=js"
export * from "./CathayPropertyCarInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports